/* global angular, PageClientData, $, $get, rtnAddToCart, cmCreateElementTag */

(function(){
  var dailyEmailLimit = 50;
  // ********************
  //
  // Angular App
  //
  // ********************

  var app = angular.module('whichProductsApp', ['ngRoute']);

  // Config
  // ********************
  app.config(['$locationProvider', '$sceDelegateProvider',
    function($locationProvider, $sceDelegateProvider) {
      $locationProvider.html5Mode(false);
      $sceDelegateProvider.resourceUrlWhitelist([
        'self',
        'http://cdn*.melaleuca.com/**',
        'https://cdn*.melaleuca.com/**'
      ]);
    }
  ]);

  // Controllers
  // ********************
  app.controller('whichProductsCtrl', ['$scope', '$sce', '$sceDelegate', '$window', '$http', 'dataService', '$q', '$timeout',
    function($scope, $sce, $sceDelegate, $window, $http, dataService, $q, $timeout) {

      // Page-level stuff
      $scope.cultureConfig = $window.searchCultureConfig;
      $scope.custStatus = $window.PageClientData.CustomerStatus; // toggle prices on/off
      $scope.cdnRoot = '';
      $scope.labels = $window.locale.labels;
      $scope.contentImagesDirectory = $window.contentImagesDirectory;
      var surveyData = $window.productSurvey.surveyData;
      $scope.signedIn = surveyData.IsAuthenticated;
      $scope.yOffSet = 0;
      $scope.exceededDailyLimitWarning = insertDailyEmailLimit($scope.labels.dailyEmailLimit);
      $scope.emailLimitExceeded = false;		
      $scope.resultsCopy = $window.locale.labels.results;		
      $scope.optionsCopy = $window.locale.labels.options;

      $scope.template = {
       url: 'https://cdn.melaleuca.com/html/product-store/' + wmUtil.docTypeCards.product
      };

      // Search params
      $scope.sortBy = '_score desc';
      $scope.size = 32;
      $scope.start = 0;

      // Price stuff for dynamically displaying customer's actual price
      $scope.swapPriceLabel = wmUtil.swapPriceCultures.includes(wmUtil.cultureKey);
      $scope.customerPriceType = window.customerPriceType.toLowerCase();
      $scope.primaryPriceLabel = $scope.cultureConfig.priceLabels[$scope.customerPriceType];
      $scope.secondaryPriceLabel = $scope.cultureConfig.priceLabels.retail;

      // Views
      $scope.views = [
        'browse',
        'results'
      ];
      $scope.view = $scope.views[0];

      // coremetrics status
      var authenticatedStatus = surveyData.IsAuthenticated ? 'signed in - ' : 'signed out - ';
      var hasSurveyCode = /whichproducts\/[A-z0-9]{6}/i.test(location.pathname);
      var fromInvite = surveyData.IsSurveyCodeValid && !surveyData.IsSurveyCodeExpired && hasSurveyCode ? 'from invite' : 'no invite';
      $scope.cmStatus = 'which products - ' + authenticatedStatus + fromInvite;

      // Display control
      $scope.modalIsOpen = false;
      $scope.isME = surveyData.IsAuthenticated; // is user signed in
      $scope.showShare = $scope.isME && checkEmailCount(); // allowed to share
      $scope.closeModal = closeModal;

      // Selected items
      $scope.buttonDisabled = true;
      $scope.loading = false;

      // Data structure
      var data = transformDisplayData(surveyData.ProductSurveyGroups);
      // check to see if there are previous selections that need to be enabled
      if (surveyData.SurveySelections) {
        data = addCheckedAttribute(data, surveyData.SurveySelections.GroupSelection);
        // enable results button because checkboxes are going to be pre checked
        $scope.buttonDisabled = false;
      }
      // check if there are services available. These are provided manually through
      // a content page `whichproducts--services`
      if ($window.servicesData) {
        data.push($window.servicesData);
        var selectedServices = [];
      }

      // console.log('data', data);
      $scope.categories = data;
      $scope.category = $scope.categories[0];
      $scope.seeMoreProducts = [];

      // email sharing
      $scope.shareMessage = $window.locale.labels.shareMessage;
      $scope.orginalShareMessage = $window.locale.labels.shareMessage;
      $scope.emailValue = '';
      $scope.sendingEmail = false;
      $scope.sendEmail = sendEmail;
      $scope.modalEmailIsOpen = false;
      $scope.emailModal = emailModal;

      // marketing executive who sent survey info
      $scope.marketingExecutiveName =
        surveyData.InvitationOwnerContactData.CustomerName;
      $scope.marketingExecutivePhone =
        surveyData.InvitationOwnerContactData.PhoneNumber;
      $scope.labels =
        populateMarketingExecInfoInLabels($scope.labels);
      $scope.enrollerID = surveyData.EnrollerId;

      // is this an invited survey
      $scope.isSurveyCode = checkForSurveyCode();
      $scope.showMEInfo =
        $scope.isSurveyCode && surveyData.IsSurveyCodeValid;

      // expired modal
      $scope.surveyIsExpired = false;
      $scope.surveyIsInvalid = false;
      $scope.expiredOrInvalidCopy = "";

      shouldExpiredOrInvalideCodeModalShow();

      $scope.changeViews = changeViews;
      $scope.checkButton = checkButton;

      $scope.addToCart = addToCart;


      function addToCart(event) { // add to cart function
        console.log('This is a test');
        var target = $(event.currentTarget);
        var cartID = wmUtil.isMobileSite ? 'btnShowMiniCart': 'miniCartIcon';
        $window.AnimateAddToDest($get(target.attr('id')), cartID);
        $window.Melaleuca.Web.AjaxManager.AddProductToCart(target.data('sku'), target.siblings('input').val(), 'which products', null, rtnAddToCart);
      }

      function shouldExpiredOrInvalideCodeModalShow() {
        if (surveyData.IsSurveyCodeExpired) {
          expiredModal('expired');
          return;
        }
        if ($scope.isSurveyCode && !surveyData.IsSurveyCodeValid) {
          expiredModal('invalid');
        }
      }

      function insertMarketingExecInfo(string) {
        return string.replace('%NAME%', $scope.marketingExecutiveName)
          .replace('%NUMBER%', $scope.marketingExecutivePhone);
      }

      function insertDailyEmailLimit(string) {
        return string.replace('%DAILYLIMIT%', dailyEmailLimit);
      }

      function populateMarketingExecInfoInLabels(labels) {
        var temp = {};
        for (var l in labels){
          temp[l] = insertMarketingExecInfo(labels[l]);
        }
        return temp;
      }

      function checkForSurveyCode() {
        return !/whichproducts(\/)?$/i.test(location.pathname);
      }

      function closeModal() {
        $scope.modalIsOpen = false;
        $scope.modalExpiredInvalidIsOpen = false;
        $scope.modalEmailIsOpen = false;
      }

      function getModalOffsetCalc() {
        return 'calc(10vh + ' + $window.pageYOffset + 'px)';
      }

      function goToTopIfMobile() {
        if (wmUtil.isMobileSite) {
          $('html,body').scrollTop(0);
        }
      }

      function emailModal() {
        $scope.yOffSet = getModalOffsetCalc();
        goToTopIfMobile();
        if(checkEmailCount()){
          $scope.modalEmailIsOpen = true;
        }
        else {
          $scope.emailLimitExceeded = true;
        }
        $scope.modalIsOpen = true;
      }

      function expiredModal(type) {
        $scope.yOffSet = getModalOffsetCalc();
        if (type === 'expired') {
          $scope.expiredOrInvalidCopy = $scope.labels.expiredModal;
          $scope.surveyIsExpired = true;
          console.log('surevey is expired');
        } else {
          $scope.surveyIsInvalid = true;
          $scope.modalIsOpen = true;
          $scope.expiredOrInvalidCopy = $scope.labels.invalidModal;
        }
        goToTopIfMobile();
      }

      // check to see if any checkbox is selected to update get
      // results button state
      function checkButton() {
        $scope.buttonDisabled = !$scope.categories.some(function(obj){
              return obj.products.some(function(_obj){
                  return _obj.value;
              });
          });
      }

      function sendEmail(){
        $scope.sendingEmail = true;
        $window.productSurvey.sendSurveyInvitation($scope.emailValue, replaceNewLines($scope.shareMessage))
        .then(function(){
          $timeout(function(){
           $scope.emailValue = '';
           $scope.shareMessage = $scope.orginalShareMessage;
           $scope.sendingEmail = false;
           closeModal();
          });
        })
        .fail(function(e){
          // handle error
          // console.log(e);
        });
        surveyData.DailyInvitationCount ++;
      }


      function replaceNewLines(str) {
        return str.replace(/\n/g,'\n');
      }

      // return boolean to determine if email sharing should be visible
      function checkEmailCount() {
        return surveyData.DailyInvitationCount < dailyEmailLimit;
      }

      function buildSearchParams(skuList) {
        return {
          id: 'products_by_sku',
          index: wmUtil.searchIndex,
          params: {
            skus: skuList,
            size: 1000
          }
        };
      }

      $scope.submitSkus = submitSkus;

      function submitSkus() {
          $scope.loading = true;
          // get all selected skus
          var s = gatherSkus($scope.categories);

          // create array of requests to search for each "category"
          var queries = s.map(function(obj){
            return dataService.getSearchResults(buildSearchParams(obj.skuQuery));
          });

          // create GroupSelection to send to our service
          function getGroupSelection() {
            return s.map(function(obj){
              var temp = {"SurveyGroupId": obj.productSurveyGroupID};
              var options = obj.products.map(function(_obj){
                return {"SurveyGroupId": obj.productSurveyGroupID,
                        "SurveyOptionId": _obj.productSurveyGroupOptionID,
                        "Sku": _obj.sku[0]
                };
              });
              temp.SurveyOptions = options;
              return temp;
            });
          }


          // only run the following code if the client is using a valid survey code
          // or has an enrollerID
          if ($scope.showMEInfo || surveyData.EnrollerId > 0) {
            // override old data with new data in original object
            $window.productSurvey.surveyData.SurveySelections = {GroupSelection : getGroupSelection()};

            // this function will send updated selected options that was stored
            // in $window.productSurvey.surveyData.SurveySelections.GroupSelection
            $window.productSurvey.saveSurveySelections();
          }

          $q.all(queries)
            .then(function(r){
              // allResults includes skus that will only be seen when the
              // see products button is clicked
                var allResults = r.map(function(obj){
                    // format results from search
                    return obj.data.hits.hits.map(function(_obj){
                      var fields = wmUtil.mapProductFields(_obj._source);
                      fields.name_no_tags = sanitizeHtml(removeTags(_obj._source.name.enhanced));
                      fields.thumbImage = _obj._source.image.mini;
                      return fields;
                    });
                })
                .map(function(arr, i){
                    // sort results so they match original order
                    var sortArray = s[i].products.map(function(o){return o.sku;});
                    var arrC = arr.slice();
                    arrC.sort(function(a, b){
                        return sortArray.indexOf(Number(a.sku)) > sortArray.indexOf(Number(b.sku));
                    });
                    return arrC;
                })
                .map(function(arr){
                  // for desktop
                  arr.dots = new Array(Math.ceil(arr.length / 4));
                  // for mobile
                  arr.mDots = new Array(Math.ceil(arr.length / 2));
                  arr.position = 0;
                  arr.showCarousel = false;
                  return arr;
                });


                // filter out the skus that are not the default/primary match to
                // a selection. These are what should be shown on the page
                var results = allResults.map(function(arr, i){
                  var filteredArr = arr.filter(function(obj){
                    return s[i].skuPrimaries.indexOf(obj.sku) !== -1;
                  });
                  return filteredArr;
                });




                $scope.allResults = allResults;
                if (allResults.length === 0) {
                  $scope.results = [];
                } else {
                  $scope.results = s.map(function(obj,i){
                      // merge results from search into original object
                      return angular.extend({}, obj, {results: results[i]});
                  })
                  .map(function(obj){
                      // tally cumulative points for each "category" results
                      return angular.extend({}, obj, {points: obj.results
                                            .reduce(function(acc,cur){
                                                return Number(cur.points) + acc;
                                            },0)});
                  })
                  .reduce(function(acc,cur,i,arr){
                      // tally all "category" points for total cumulative points
                      if (i < arr.length - 1) {
                          return cur.points + acc;
                      } else {
                          arr.totalPoints = cur.points + acc;
                          return arr;
                      }
                  },0);
                }

                if ($window.servicesData) {
                  if (selectedServices.products.length){
                    $scope.results.push(selectedServices);
                  }
                }


                // console.log($scope.results);
                changeViews();
                $scope.loading = false;
            });
      }

      function changeViews(){
          var c = $scope.views.indexOf($scope.view);
          $scope.view = $scope.views[(c + 1) % 2];
          $(document).scrollTop(0);
      }

      function gatherSkus (_categories) {
       if ($window.servicesData) {
         // get the selected services and make the data look similar to the
         // product data that will be shown on the page. selectedServices will
         // be pushed on to the end of the results.
         selectedServices = _categories.filter(function(obj){
              return obj.isServices;
            })
            .map(function(obj){
                obj.points = 0;
                var prods = obj.products.filter(function(_obj){ return _obj.value;});
                return angular.extend({}, obj, {products: prods}, {results: prods});
            })
            .reduce(function(acc, curr){
              return curr;
            },[]);
       }
       var temp = _categories
            .filter(function(obj){
              return obj.isServices != true;
            })
            .filter(function(obj){
                return obj.products.some(function(_obj){
                    return _obj.value;
                });
            });
        // this is if only services have been selected
        if (temp.length == 0) return [];
        return temp.map(function(obj){
                var prods = obj.products.filter(function(_obj){ return _obj.value;});
                return angular.extend({}, obj, {products: prods});
            })
            // these will be all the skus that need to be retrieved. Some will not
            // be displayed untill the see products button is clicked
            .map(function(obj){
                var skuQuery = obj.products.reduce(function(acc,cur){
                    var temp = acc.concat(cur.sku);
                    return temp;
                },[]);
                return angular.extend({},obj,{skuQuery:skuQuery});
            })
            // these should be the skus that are displayed as results
            .map(function(obj){
                var skuPrimaries = obj.products.reduce(function(acc,cur){
                    acc.push(cur.sku[0]);
                    return acc;
                },[]);
                return angular.extend({},obj,{skuPrimaries:skuPrimaries});
            });
      }

      function getSortOrder(a, b) {
        var val1 = a.LocalizedDescriptions
                    .filter(function(o){ return o.CultureID === wmUtil.culture;})
                    .reduce(function(acc,curr){ return acc + curr.SortOrder;},0);
        var val2 = b.LocalizedDescriptions
                    .filter(function(o){ return o.CultureID === wmUtil.culture;})
                    .reduce(function(acc,curr){ return acc + curr.SortOrder;},0);
        return val1 - val2;
      }

      function addCheckedAttribute(arr, oldSelections) {
        // get an array of Ids from categories that were previously selected
        var surveyGroupIds = oldSelections.map(function(o){return o.SurveyGroupId;});
        return arr.map(function(obj){
          if (surveyGroupIds.indexOf(obj.productSurveyGroupID) != -1) {
            // get an array of Ids from options that were previously selected
            var surveyOptionIds = oldSelections
                                .filter(function(o){
                                  return o.SurveyGroupId == obj.productSurveyGroupID;
                                })
                                // only care about the first index value
                                .reduce(function(acc, curr){
                                  return curr.SurveyOptions;
                                },[])
                                .map(function(o){
                                  return o.SurveyOptionId;
                                });
            obj.products = obj.products.map(function(o){
              if (surveyOptionIds.indexOf(o.productSurveyGroupOptionID) != -1) {
                o.checked = true;
              }
              return o;
            });
          }
          return obj;

        });
      }

      function transformDisplayData(arr){
        return arr.filter(function(o){ return o.IsActive; })
                  .filter(function(o){ return o.LocalizedDescriptions.some(function(_o){
                    return _o.CultureID === wmUtil.culture;
                  });})
                  .filter(function(o){return o.ProductSurveyOptions.length > 0;})
                  .sort(getSortOrder)
          .map(function(o){
            var temp = {title: getTitle(o.LocalizedDescriptions)};
            var products = o.ProductSurveyOptions
                  .filter(function(_o){ return _o.IsActive;})
                  // remove options that don't have a localization for this culture
                  .filter(function(_o){ return _o.LocalizedDescriptions.some(function(__o){
                    return __o.CultureID === wmUtil.culture;
                  });})
                  // remove options that dont have any skus
                  .filter(function(_o){ return _o.Products.some(function(__o){
                    return __o.CountryID === surveyData.CountryId;
                  });})
                  .sort(getSortOrder)
                  .map(function(_o) {
                    var _temp = {
                      title: getTitle(_o.LocalizedDescriptions),
                      sku: getSku(_o.Products),
                      productSurveyGroupOptionID: _o.ProductSurveyGroupOptionID,
                      checked: false
                    };
                    return _temp;
                  });
            temp.products = products;
            temp.productSurveyGroupID = o.ProductSurveyGroupID;

            return temp;
          });
      }

      function getTitle(arr) {
        return arr.filter(function(o){ return o.CultureID === wmUtil.culture; })
                  .reduce(function(acc,curr){ return curr.Description + acc; },'');
      }

      function getSku(arr){
        return arr.slice()
        .filter(function(o){return o.CountryID === surveyData.CountryId;})
        .sort(function(a,b){
          if (a.IsDefault){
            return -1;
          } else if (b.IsDefault) {
            return 1;
          } else {
            return 0;
          }
        })
        .map(function(o){
          return o.Sku;
        });

      }

      function removeTags(a) {
          return a.replace(/<span[A-z 0-9="'\-#:;]+>([()A-z 0-9$\.]+)<\/span>/g,'$1')
                  .replace(/\(.+\)/g,'')
                  .replace(/save.+/i,'')
                  .replace(/(&mdash;).+$/,'');
      }

      function sanitizeHtml(content){
        return $sce.trustAsHtml(content);
      }
    }
  ])
  .directive("cm", function () {
        return {
            restrict: 'A',
            scope: {
              cm: '@cm'
            },
            link: function (scope, element, attrs) {
                element.on('click', function (e) {
                  e.stopPropagation();
                  var catID = decodeURIComponent(attrs.cm);
                  cmCreateElementTag(catID, scope.$parent.cmStatus, standardElementAnalyticsAttributes);
                });
            }
        };
    })
    .directive('spacepress', [function(){
      return {
        restrict: 'A',
        link: function (scope, element) {
          element.on('keydown', function(e){
            if (e.which == 32) {
              e.preventDefault();
              e.target.click();
            }
          });

        }
      };
    }])
    .directive('carouseldrag', ['$document', '$timeout', function($document, $timeout){
      return {
        restrict: 'A',
        link: function (scope, element) {
          var startX = 0;
          var compareX = 0;
          var give = 50;

          element.on('touchstart',function(e) {
            startX = parseInt(e.originalEvent.changedTouches[0].clientX);
            compareX = parseInt(e.originalEvent.changedTouches[0].clientX);
          });

          element.on('touchmove',function(e) {
            compareX = parseInt(e.originalEvent.changedTouches[0].clientX);
            // element.css({
            //   right: x + 'px'
            // });
          });

          element.on('touchend',function(e) {
            if (compareX > startX + give) {
              if (scope.$parent.products.position > 0 ) {
                $timeout(function(){
                  scope.$parent.products.position -= 1;
                });
              }
            }
            if (compareX < startX - give) {
                // console.log(scope.$parent.products.position, scope.$parent.products.mDots.length - 1);
              if (scope.$parent.products.position < scope.$parent.products.mDots.length - 1) {
                $timeout(function(){
                  scope.$parent.products.position += 1;
                });
              }
            }
            // console.log(scope);
            startX = 0;
            compareX = 0;
          });
        }
      };
    }])
    .directive('addTargetAttr', ['$timeout', function($timeout){
      return {
        restrict: 'A',
        link: function (scope, element){
          $timeout(function(){
            angular.element(element).find('a').attr('target','_blank');
          });
        }
      };
    }]);

  angular.bootstrap(document.getElementById('which-products-app'),['whichProductsApp', 'ngWmUtil']);

})();
